import Highcharts from 'highcharts';

const INLINED_SVG_IMAGE_PREFIX = 'data:image/svg+xml';

export function applyHighchartsDefaults() {
  if (!Highcharts.AST.allowedReferences.includes(INLINED_SVG_IMAGE_PREFIX)) {
    Highcharts.AST.allowedReferences.push(INLINED_SVG_IMAGE_PREFIX);
  }

  Highcharts.setOptions({
    credits: {
      enabled: false,
    },
    lang: {
      thousandsSep: ',',
    },
  });
}
